// extracted by mini-css-extract-plugin
export default {"container":"DoubleVisualMediaContainer__container___aqol3","image":"DoubleVisualMediaContainer__image___GVehf"};